// Set image to a public URL after adding your screenshot, e.g.
// image: "/images/careipd/screenshots/dashboard.webp". See the README in that folder.
const careIpdModules = [
  {
    id: "dashboard", title: "Dashboard", image: "/images/careipd/generated/dashboard-admission-1586.webp",
    imageAlt: "Screenshot-based desktop mockup of the Care IPD dashboard and admission screen",
    imageCaption: "Dashboard and admission · Product visual",
    description: "See admissions, beds, pending work and billing in one overview.",
    groups: [{ items: ["Monthly calendar of events", "Ward/bed status panel", "Alerts panel", "Today’s IPD admissions table", "Discharge clearance queue", "Nursing pending tasks", "Billing summary"] }],
  },
  {
    id: "patient-registration", title: "Patient registration", image: null,
    description: "Register patients and find their details when your team needs them. UHID is the patient’s unique hospital identification number.",
    groups: [{ items: ["Patient registration", "Search patient", "Edit patient details", "Patient documents", "UHID history", "Emergency contact details"] }],
  },
  {
    id: "ipd", title: "IPD workflow", image: "/images/careipd/generated/dashboard-admission-1586.webp",
    imageAlt: "Care IPD admission screen alongside the dashboard in a product mockup",
    imageCaption: "Dashboard and admission · Product visual",
    description: "Manage inpatient care: patients who are admitted to your hospital, from admission through discharge.",
    groups: [
      { title: "Admissions & beds", items: ["New IPD admission", "IPD patient list", "Bed allocation", "Bed transfer", "Ward/bed board"] },
      { title: "Care & clinical notes", items: ["Doctor round notes", "Nursing notes", "Vitals chart"] },
      { title: "Discharge & reports", items: ["Discharge request", "Discharge summary", "IPD reports", "My IPD reports"] },
    ],
  },
  {
    id: "opd", title: "OPD workflow", image: "/images/careipd/generated/opd-registration-1586.webp",
    imageAlt: "Screenshot-based desktop mockup of Care IPD OPD registration",
    imageCaption: "OPD registration · Product visual",
    description: "Manage outpatient visits: patients coming for consultations, treatment or follow-up without an inpatient admission.",
    groups: [
      { title: "Registration & queues", items: ["OPD dashboard", "OPD registration", "Token/queue management", "Doctor OPD queue"] },
      { title: "Consultations & treatment", items: ["OPD consultation", "Prescription", "Lab orders", "Radiology orders", "Procedures", "Follow-up", "OPD to IPD conversion"] },
      { title: "Billing & reports", items: ["OPD billing", "OPD pharmacy", "OPD reports"] },
    ],
  },
  {
    id: "billing", title: "Billing", image: null,
    description: "Review patient bills, print them and record quick inpatient payments.",
    groups: [{ items: ["Patient bill history", "Bill print", "IPD quick payment"] }],
  },
  {
    id: "pharmacy", title: "Pharmacy", image: null,
    description: "Handle medicine sales and requests, track stock movements and check expiry alerts.",
    groups: [
      { title: "Sales & dispensing", items: ["Medicine billing", "Sales history", "Payments", "Medicine requests", "Medicine issue", "Medicine return"] },
      { title: "Stock management", items: ["Stock view", "Add stock", "Stock adjustment", "Expiry alerts"] },
    ],
  },
  {
    id: "settings", title: "Masters and settings", image: null,
    description: "Set up the hospital’s reference lists, such as doctors and wards, and manage application preferences and connection settings.",
    groups: [
      { title: "Hospital, team & medicine lists", items: ["Department master", "Doctor master", "User master", "Role master", "Ward master", "Room master", "Bed master", "Medicine master"] },
      { title: "Billing & record settings", items: ["Payment mode master", "Print template master", "UHID settings", "GST settings", "Financial year settings"] },
      { title: "Application & database settings", items: ["Local setup settings", "Theme settings", "Status color settings", "App preferences", "Database settings", "DB connection", "License settings"] },
    ],
  },
];
module.exports = careIpdModules;
